export default __webpack_public_path__ + "static/media/Do-documentation.48bc0fc8.md";